/** @jsx h */
import { h } from 'preact';
import AivfInfo from './aivfInfo';

const AivfInfoModal = ({ closeModal }) => {
  return <AivfInfo closeModal={closeModal} />;
};

export default AivfInfoModal;



// WEBPACK FOOTER //
// ./components/partial/layers/modals/aivfInfoModal/index.js